/*SYSTEM IMPORTS*/
    import React from 'react'
    // import c from 'classnames'


    const UserIcon = () => (
        <div className="user-icon">
            <svg width="29" height="34" viewBox="0 0 29 34" fill="none">
                <rect width="29" height="34" fill="black" fillOpacity="0"/>
                <rect width="16.4715" height="16.9453" fill="black" fillOpacity="0" transform="translate(6.03223)"/>
                <path d="M14.268 16.9453C18.8165 16.9453 22.5037 13.152 22.5037 8.47267C22.5037 3.79334 18.8165 0 14.268 0C9.7195 0 6.03223 3.79334 6.03223 8.47267C6.03223 13.152 9.7195 16.9453 14.268 16.9453Z" fill="#FFC56B"/>
                <rect width="29" height="15.3601" fill="black" fillOpacity="0" transform="translate(0 18.6399)"/>
                <path d="M1.09114 34H27.8706C28.5614 34 29.0927 33.3441 28.9864 32.6335C27.233 24.5434 21.4414 18.6399 14.4809 18.6399C7.52034 18.6399 1.72875 24.5434 0.0284647 32.6335C-0.130937 33.3441 0.400402 34 1.09114 34Z" fill="#FFC56B"/>
            </svg>
        </div>
    )

    export default UserIcon
